<article class="facility-overview-card">
  <header class="facility-overview-card__header">
    <h3 class="facility-overview-card__title">
      @if (canOpenDevices()) {
        <!-- Ссылка растянута на всю карточку. -->
        <a
          class="facility-overview-card__link"
          [routerLink]="devicesListUrl"
          [queryParams]="devicesQueryParams()"
          [title]="'monitoring.devices.links.facility' | translate"
          >{{ facility().facilityName }}</a
        >
      } @else {
        {{ facility().facilityName }}
      }
    </h3>
  </header>

  <div class="facility-overview-card__metrics">
    <div class="metric-item">
      <lib-svg-icon
        class="metric-item__icon icon-work"
        icon="pick"
        size="32"
      />
      <span class="metric-item__value">{{ facility().workingCount }}</span>
      <span class="metric-item__label">{{
        'monitoring.dashboard.facilities-overview.facility-card.in-work' | translate
      }}</span>
    </div>

    <div class="metric-item">
      <lib-svg-icon
        class="metric-item__icon icon-free"
        icon="space"
        size="32"
      />
      <span class="metric-item__value">{{ facility().freeCount }}</span>
      <span class="metric-item__label">{{
        'monitoring.dashboard.facilities-overview.facility-card.free' | translate
      }}</span>
    </div>

    <div class="metric-item">
      <lib-svg-icon
        class="metric-item__icon icon-repair"
        icon="screwdriver"
        size="32"
      />
      <span class="metric-item__value">{{ facility().underRepairCount }}</span>
      <span class="metric-item__label">{{
        'monitoring.dashboard.facilities-overview.facility-card.repair-zone' | translate
      }}</span>
    </div>

    <div class="metric-item">
      <lib-svg-icon
        class="metric-item__icon icon-offline"
        icon="internet-off"
        size="32"
      />
      <span class="metric-item__value">{{ facility().offlineCount }}</span>
      <span class="metric-item__label">{{
        'monitoring.dashboard.facilities-overview.facility-card.offline' | translate
      }}</span>
    </div>
  </div>

  <div class="facility-overview-card__status-bar status-bar">
    @for (segment of segments(); track segment.type) {
      <div
        class="status-bar__segment status-bar__segment--{{ segment.type }}"
        [style.width.%]="segment.width"
      ></div>
    }
  </div>
</article>
